
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { WenFangCardType } from '@xt/client/types/home.d'
import Qrcode from '@xt/www/components/showQrcode/index.vue'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource: WenFangCardType

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
